<template>
  <div>
    <header class="header_title">
      <div class="text"><span>客服管理/自动回复</span></div>
      <el-button type="primary" size="mini" @click="addBackClick">返回</el-button>
    </header>
    <div class="new_container" id='setHeightDom' :style="{height:height}">
      <el-form :model="ruleForm" size="small" :rules="rules" ref="ruleForm" label-suffix=":" label-width="100px"
        class="reply-ruleForm">
        <el-form-item label="规则名称" prop="ruleName">
          <el-input class="rule-name" :disabled='!isEdite' placeholder="请输入规则名称" @input="changeInput"
            v-model.trim="ruleForm.ruleName">
          </el-input>
        </el-form-item>
        <el-form-item :label="index==0?'关键字':''" :prop="'keywordJson.' + index + '.keyword'" :rules="rules.resource"
          v-for="(item,index) in ruleForm.keywordJson" :key="index">
          <div class="key_word">
            <el-radio-group v-model="item.keyWay" :disabled='!isEdite' @change='changeRadio'>
              <el-radio label="half">半匹配</el-radio>
              <el-radio label="all">全匹配</el-radio>
            </el-radio-group>
            <el-input class="keyword-input" placeholder="请输入关键字" :disabled='!isEdite' @input="changeInput" v-model.trim="item.keyword">
            </el-input>
            <img class="edite-img" @click="addKeyword" v-if="index==0 && isEdite" src="@/assets/images/add.png" alt="">
            <img class="edite-img" v-if="index!=0 && isEdite" src="@/assets/images/cut.png" alt="" @click="delWordClick(index)">
          </div>
        </el-form-item>
        <el-form-item label="回复内容" prop="replyContentJson">
          <div class="words-type-box" v-if="typeList1.length">
            <div class="words-type" v-for="(item,index) in typeList1" :key="index">
              <div class="set-flex">
                <div>
                  {{item.characters}}
                </div>
                <img src="@/assets/images/edite.png" v-if="isEdite" alt="" class="edite-img"
                  @click='editeText(item,index)'>
                <img src="@/assets/images/close.png" v-if="isEdite" class="close-img"
                  @click="delConClick(1,item,index)">
              </div>
            </div>
          </div>
          <div class="upload-img-box" v-if="typeList2.length">
            <span v-for="(item,index) in typeList2" :key="index">
              <img :src="item.url" class="upload-img">
              <img src="@/assets/images/close.png" class="close-img" v-if="isEdite" @click="delConClick(2,item,index)">
            </span>
          </div>
          <div class="other-box" v-if="typeList3.length">
            <div class="media-box" v-for="(item,index) in typeList3" :key="index">
              <div>
                <div class="name">{{item.name}}</div>
                <span>{{item.update_time | formateDate}}</span>
              </div>
              <div class="time-box">
                <img src="@/assets/images/audio.png" class="upload-img">
                <!-- <div class="time">05:00</div> -->
              </div>
              <img src="@/assets/images/close.png" class="close-img" v-if="isEdite" @click="delConClick(3,item,index)">
            </div>
          </div>
          <div class="other-box" v-if="typeList4.length">
            <div class="media-box" v-for="(item,index) in typeList4" :key="index">
              <div>
                <div class="name">{{item.name}}</div>
                <span>{{item.update_time | formateDate}}</span>
              </div>
              <div class="time-box">
                <img :src="item.url" class="upload-img">
                <i class="el-icon-video-play"></i>
                <!-- <div class="time">05:00</div> -->
              </div>
              <img src="@/assets/images/close.png" class="close-img" v-if="isEdite" @click="delConClick(4,item,index)">
            </div>
          </div>
          <div :class="ruleForm.replyContentJson && ruleForm.replyContentJson.length?'set-mar-small':'set-mar-mini'"
            v-if="isEdite">
            <el-button type="primary" icon="el-icon-plus" @click="showDialog(0)">文字</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="showDialog(1)">图片</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="showDialog(2)">音频</el-button>
            <el-button type="primary" icon="el-icon-plus" @click="showDialog(3)">视频</el-button>
          </div>
        </el-form-item>
        <el-form-item label="回复方式" prop="replyWay" class="set-disabled">
          <el-radio-group v-model="ruleForm.replyWay" :disabled='!isEdite' @change='changeRadio'>
            <el-radio label="random">随机回复一条</el-radio>
            <el-radio label="all">回复全部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="btn-box" v-if="isEdite">
          <el-button @click="resetForm('ruleForm')">重置</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog class="replay-dialog-img" :close-on-click-modal="false" title="添加回复文字" center
      :visible.sync="dialogReply0">
      <div class="dialog-con">
        <div class="words-box">
          <el-input class="words" type="textarea" placeholder="请输入文本" @input='handleWordsNum' v-model="textarea"
            maxlength="1000"></el-input>
          <div class="limit-box">
            <div class="cur" @click="addLink">添加一个超链接</div>
            <div>还可以输入{{wordsNum}}字，按下Enter健换行</div>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button size="small" @click="dialogReply0 = false">取消</el-button>
          <el-button size="small" type="primary" @click="onSaveWord">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- v-if="dialogReply1 == 'on'" -->
    <imgDialog ref='imgCom' :publicId='publicId' @getImgObj='getImgObj' />
    <audioDialog ref='audioCom' :publicId='publicId' @getVoiceObj='getVoiceObj' />
    <videoDialog ref='videoCom' :publicId='publicId' @getVideoObj='getVideoObj' />
  </div>
</template>
<script>
import { formateDate } from "../../commen/date.js";
import imgDialog from "./components/imgdialog.vue";
import videoDialog from "./components/videosdialog.vue";
import audioDialog from "./components/audiodialog.vue";
import { getReplyDetails, saveReply, editeReply } from "./api/index.js";
export default {
  components: {
    imgDialog,
    audioDialog,
    videoDialog
  },
  filters: {
    formateDate(time) {
      time = time * 1000;
      return formateDate(time);
    }
  },
  data() {
    return {
      editeFlag: false,
      id: "",
      dialogReply0: false,
      dialogReply1: false,
      dialogReply2: false,
      dialogReply3: false,
      wordsNum: 1000,
      textarea: "",
      ruleForm: {
        ruleName: "",
        replyWay: "",
        replyType: "keyword",
        keywordJson: [{ keyWay: "all", keyword: "" }],
        replyContentJson: []
      },
      rules: {
        ruleName: [
          {
            required: true,
            message: "规则名称最多60个字，且不能为空",
            trigger: "blur"
          },
          {
            min: 1,
            max: 60,
            message: "规则名称最多60个字，且不能为空",
            trigger: "blur"
          }
        ],
        replyWay: [
          {
            required: true,
            message: "请选择回复方式！",
            trigger: "change"
          }
        ],
        resource: [
          {
            required: true,
            message: "关键字最多30个字，且不能为空",
            trigger: "blur"
          },
          {
            min: 1,
            max: 30,
            message: "关键字最多30个字，且不能为空",
            trigger: "blur"
          }
        ],
        replyContentJson: [
          {
            required: false,
            message: "回复内容至少一条"
          }
        ]
      },
      isEdite: true,
      typeList1: [],
      typeList2: [],
      typeList3: [],
      typeList4: [],
      addNum: 0,
      wordsFlag: null,
      height: "500px"
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetailsData();
    }
    if (this.$route.query.publicId) {
      this.publicId = this.$route.query.publicId;
    }
    if (this.$route.query.isEdite) {
      this.isEdite = false;
    }
  },
  mounted() {
    this.height = this.handleHeight() + "px";
  },
  methods: {
    changeInput() {
      this.editeFlag = true;
    },
    addLink() {
      let str = '<a href="你要放入的链接">起个名字</a>';
      if (1000 - this.textarea.length >= str.length) {
        this.textarea = this.textarea + str;
      }
      this.handleWordsNum();
    },
    editeText(item, index) {
      this.editeFlag = true
      this.wordsFlag = index;
      this.dialogReply0 = true;
      this.textarea = item.characters;
      this.wordsNum = 1000 - item.characters.length;
    },
    handleWordsNum() {
      if (1000 - this.textarea.length > 0) {
        this.wordsNum = 1000 - this.textarea.length;
      } else {
        this.wordsNum = 0;
      }
    },
    addKeyword() {
      if (this.ruleForm.keywordJson.length < 5) {
        let obj = { keyWay: "all", keyword: "" };
        this.ruleForm.keywordJson.push(obj);
        this.editeFlag = true;
      } else {
        this.$message.error("最多只能添加5条！");
      }
    },
    changeRadio(v) {
      this.editeFlag = true;
    },
    delWordClick(index) {
      this.editeFlag = true;
      this.ruleForm.keywordJson.splice(index, 1);
    },
    onSaveWord() {
      if (this.textarea.trim().replace(/[\r\n]/g, "").length < 1) {
        this.$message.error("请输入文本！");
      } else {
        let obj = {
          characters: this.textarea,
          msgType: "text",
          mediaId: ""
        };
        if (this.wordsFlag != null) {
          this.typeList1[this.wordsFlag] = obj;
        } else {
          this.typeList1.push(obj);
          this.addNum = this.addNum + 1;
        }
        this.dialogReply0 = false;
      }
    },
    getImgObj(data) {
      data.msgType = "image";
      this.typeList2.push(data);
      this.addNum = this.addNum + 1;
      this.$refs["ruleForm"].clearValidate(["replyContentJson"]);
    },
    getVoiceObj(data) {
      data.msgType = "voice";
      this.typeList3.push(data);
      this.addNum = this.addNum + 1;
      this.$refs["ruleForm"].clearValidate(["replyContentJson"]);
    },
    getVideoObj(data) {
      data.msgType = "video";
      data.url = data.cover_url;
      this.typeList4.push(data);
      this.addNum = this.addNum + 1;
      this.$refs["ruleForm"].clearValidate(["replyContentJson"]);
    },
    delConClick(n, item, index) {
      //删除当前展示内容
      this.editeFlag = true
      //文字
      if (n == 1) {
        let eq1 = null;
        this.typeList1.map((child, val) => {
          if (index == val) {
            eq1 = val;
          }
        });
        if (eq1 != null) {
          this.typeList1.splice(eq1, 1);
        }
      }
      //图片
      if (n == 2) {
        let eq2 = null;
        this.typeList2.map((child, val) => {
          if (index == val) {
            eq2 = val;
          }
        });
        if (eq2 != null) {
          this.typeList2.splice(eq2, 1);
        }
      }
      //音频
      if (n == 3) {
        let eq3 = null;
        this.typeList3.map((child, val) => {
          if (index == val) {
            eq3 = val;
          }
        });
        if (eq3 != null) {
          this.typeList3.splice(eq3, 1);
        }
      }
      //视频
      if (n == 4) {
        let eq4 = null;
        this.typeList4.map((child, val) => {
          if (index == val) {
            eq4 = val;
          }
        });
        if (eq4 != null) {
          this.typeList4.splice(eq4, 1);
        }
      }
      if (this.addNum) {
        this.addNum = this.addNum - 1;
      } else {
        this.addNum = 0;
      }
    },
    getDetailsData() {
      getReplyDetails(this.id).then(res => {
        if (res.code == 0) {
          let end = res.data;
          this.ruleForm.ruleName = end.ruleName;
          this.ruleForm.replyWay = end.replyWay;
          this.ruleForm.keywordJson = end.keywordJson ? end.keywordJson : [];
          if (end.replyContentJson && end.replyContentJson.length) {
            this.addNum = end.replyContentJson.length;
            end.replyContentJson.map(item => {
              if (item.msgType == "text") {
                this.wordsNum = 1000 - item.characters.length;
                this.typeList1.push(item);
              }
              if (item.msgType == "image") {
                this.typeList2.push(item);
              }
              if (item.msgType == "voice") {
                this.typeList3.push(item);
              }
              if (item.msgType == "video") {
                this.typeList4.push(item);
              }
            });
          }
        }
      });
    }, 
    showDialog(num) {
      if (this.addNum > 4) {
        this.$message.error("最多只能上传5条！");
        return;
      }
      this.editeFlag = true
      if (num == 0) {
        this.wordsFlag = null;
        this.textarea = "";
        this.wordsNum = 1000;
        this.dialogReply0 = true;
      } else if (num == 1) {
        this.dialogReply1 = true;
        this.$refs.imgCom.openDialog();
      } else if (num == 2) {
        this.dialogReply2 = true;
        this.$refs.audioCom.openDialog();
      } else if (num == 3) {
        this.dialogReply3 = true;
        this.$refs.videoCom.openDialog();
      }
    },
    save() {
      this.ruleForm.replyContentJson = [
        ...this.typeList1,
        ...this.typeList2,
        ...this.typeList3,
        ...this.typeList4
      ];
      if (this.ruleForm.replyContentJson.length < 1) {
        this.$message.error("回复内容至少选择一条！");
        return;
      }
      let params = this.ruleForm;
      params.publicId = this.publicId;
      if (this.id) {
        params.id = this.id;
        editeReply(params).then(res => {
          if (res.code == 0) {
            this.$message.success("更新成功");
            this.$router.go(-1);
          }
        });
      } else {
        saveReply(params).then(res => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            this.$router.go(-1);
          }
        });
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.addNum = 0;
      this.ruleForm = this.$options.data().ruleForm;
      this.typeList1 = this.$options.data().typeList1;
      this.typeList2 = this.$options.data().typeList2;
      this.typeList3 = this.$options.data().typeList3;
      this.typeList4 = this.$options.data().typeList4;
      this.$refs[formName].resetFields();
    },
    addBackClick() {
      if (this.editeFlag && this.isEdite) {
        this.$confirm("内容尚未保存，是否退出？", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          center: true,
          customClass: "del-dialog"
        })
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>
<style lang="less" >
.el-message-box.del-dialog {
  /deep/.el-message-box__message p {
    color: #000;
  }
}
</style>
<style scoped lang="less">
.header_title {
  width: 100%;
  overflow: hidden;
  padding: 20px 24px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #333333;
    font-size: 14px;
    span:nth-child(2) {
      color: #000000;
    }
    span:nth-child(1) {
      color: #666666;
    }
  }
}
.key_word,
.set-disabled {
  .is-disabled /deep/.el-radio__label {
    color: #606266;
  }
  .is-checked /deep/.el-radio__label {
    color: #1a7bfc;
  }
  .is-checked /deep/.el-radio__inner {
    background: #1a7bfc;
  }
}
.dialog-btn {
  margin-top: 47px;
  /deep/.el-button {
    width: 110px;
    margin-right: 30px;
  }
}
.replay-dialog-img {
  /deep/.el-dialog {
    width: 880px;
    height: 610px;
    border-radius: 2px;
  }
}

.dialog-con {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 65px;
}

.words-box {
  width: 820px;
  height: 380px;
  border-radius: 20px;
  border: 1px solid #979797;
  padding: 25px 32px;
  overflow: hidden;
}
.words.el-textarea {
  padding: 0;
  height: 290px;
  margin-bottom: 20px;
  /deep/.el-textarea__inner {
    height: 100%;
    border: none;
    resize: none;
    padding: 0;
  }
}
.limit-box {
  display: flex;
  justify-content: space-between;
  color: #333;
  line-height: 17px;
  font-weight: bold;
  .cur {
    color: #1a7bfc;
    cursor: pointer;
  }
}
.btn-box {
  margin-left: 100px;
  /deep/.el-button {
    width: 110px;
    margin-right: 30px;
  }
}
.new_container {
  margin: 22px 16px;
  padding: 20px 25px;
  background: #fff;
  overflow: auto;
}
.rule-name {
  max-width: 740px;
}
.keyword-input {
  width: 280px;
  margin-left: 24px;
}
.edite-img {
  width: 28px;
  height: 28px;
  margin-left: 8px;
  vertical-align: middle;
  cursor: pointer;
}
.set-mar-mini {
  margin-top: 10px;
}
.set-mar-small {
  margin-top: 20px;
}
.upload-img-box {
  margin-top: 20px;
  padding-top: 10px;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  span {
    position: relative;
  }

  .upload-img {
    width: 74px;
    height: 74px;
    margin-right: 16px;
    display: block;
    border-radius: 4px;
  }
}
.close-img {
  width: 16px;
  height: 16px;
  position: absolute;
  left: 72px;
  top: -8px;
  z-index: 2;
  cursor: pointer;
}
.other-box {
  overflow: hidden;
}
.media-box {
  width: 260px;
  height: 120px;
  display: flex;
  justify-content: space-between;
  padding: 20px 18px;
  background: #f5f5f5;
  border-radius: 15px;
  font-size: 14px;
  margin-top: 20px;
  color: #333333;
  float: left;
  align-items: center;
  position: relative;
  margin-right: 16px;
  .el-icon-video-play {
    position: absolute;
    top: 47px;
    left: 190px;
    color: #fff;
    font-size: 30px;
  }
  .upload-img {
    width: 74px;
    height: 74px;
    border-radius: 4px;
    display: block;
  }
  .name {
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .close-img {
    left: 250px;
  }
}
.time-box {
  // position: relative;
  .time {
    position: absolute;
    width: 74px;
    height: 74px;
    color: #fff;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 74px;
    font-size: 18px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 15px;
  }
}
.words-type-box {
  display: flex;
  flex-wrap: wrap;
}

.words-type {
  margin-top: 20px;
  margin-right: 16px;
  height: 0;
  padding: 12px;
  display: table;
  background: #f5f5f5;
  border-radius: 15px;
  position: relative;
  align-items: center;
  div {
    width: 434px;
    font-size: 12px;
    line-height: 18px;
  }
  .close-img {
    top: -10px;
    left: 445px;
  }
  .set-flex {
    display: flex;
    align-items: center;
    word-break: break-all;
  }
}
</style>

